// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Grid2, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './SettingBoxItem.module.scss';

type Props = {
  title?: string;
  subTitle?: string;
  icon?: string;
  onClick?: () => void;
};

const cx = classNames.bind(styles);

const SettingBoxItem = (props: Props) => {
  //#region Destructuring Props
  const { title, subTitle, icon, onClick } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Grid2 id='settingBoxItemComponent' size={4}>
      <Stack className={cx('viewBox')} alignItems={'center'} onClick={onClick}>
        <Box className={cx('iconBox')}>
          <img src={icon} alt={t('common_img_text_alt')} className={cx('searchIcon')} />
        </Box>

        <Typography className={cx('title')}>{title}</Typography>

        <Typography className={cx('subTitle')}>{subTitle}</Typography>
      </Stack>
    </Grid2>
  );
};

export default SettingBoxItem;
